function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM16 8.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
  fill: "currentColor"
});

function SvgElipsisH16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMi41IDEwQzMuMzI4NDMgMTAgNCA5LjMyODQzIDQgOC41QzQgNy42NzE1NyAzLjMyODQzIDcgMi41IDdDMS42NzE1NyA3IDEgNy42NzE1NyAxIDguNUMxIDkuMzI4NDMgMS42NzE1NyAxMCAyLjUgMTBaTTguNSAxMEM5LjMyODQzIDEwIDEwIDkuMzI4NDMgMTAgOC41QzEwIDcuNjcxNTcgOS4zMjg0MyA3IDguNSA3QzcuNjcxNTcgNyA3IDcuNjcxNTcgNyA4LjVDNyA5LjMyODQzIDcuNjcxNTcgMTAgOC41IDEwWk0xNiA4LjVDMTYgOS4zMjg0MyAxNS4zMjg0IDEwIDE0LjUgMTBDMTMuNjcxNiAxMCAxMyA5LjMyODQzIDEzIDguNUMxMyA3LjY3MTU3IDEzLjY3MTYgNyAxNC41IDdDMTUuMzI4NCA3IDE2IDcuNjcxNTcgMTYgOC41WiIgZmlsbD0iY3VycmVudENvbG9yIiAvPgo8L3N2Zz4K";
export { SvgElipsisH16 as ReactComponent };